import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Box, Collapse } from "@mui/material";
import React from "react";

import { TestIds } from "@storyboard/web-test-ids/testIds";
import RecipientFeedList from "@/components/RecipientFeedList";
import theme from "@/theme/theme.tsx";

export default React.memo(function SelectGroupsOfFeeds({
  data,
  index,
  openGroups,
  toggleOpenGroup,
  toggleAllGroupFeeds,
  activeChannels,
  toggleSingleFeed,
  containerClassList,
}: {
  data: any;
  index: number;
  openGroups: string[];
  toggleOpenGroup: (value: string) => void;
  toggleAllGroupFeeds: (value: string[]) => void;
  activeChannels: string[];
  toggleSingleFeed: (value: string) => void;
  containerClassList: { active: object; inactive: object };
}) {
  const activeClass = (data: { id: string }[]) =>
    data?.some((feed) => activeChannels.includes(feed.id)) ? containerClassList.active : containerClassList.inactive;

  return (
    <Box key={`select-groups-of-feeds-${index}`}>
      {data?.length > 0 && (
        <Box>
          {data.map((group) => (
            <Box key={group.id} sx={{ mb: 2, ...activeClass(group.feeds) }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Box
                  data-sb={TestIds.fleet.recipientGroup}
                  sx={{
                    display: "flex",
                    cursor: "pointer",
                    alignItems: "center",
                    gap: 1,
                  }}
                  onClick={() => toggleOpenGroup(group.id)}
                >
                  <Box sx={{ display: "flex" }}>
                    {openGroups.includes(group.id) ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                  </Box>
                  <Box sx={{ fontWeight: "bold", display: "flex" }}>
                    {group.name} ({group.feeds.length})
                  </Box>
                </Box>
              </Box>
              <Collapse in={openGroups.includes(group.id)} unmountOnExit mountOnEnter>
                <Box sx={{ mt: 1, p: 1 }}>
                  {group?.feeds?.length > 1 && (
                    <Box
                      data-sb={TestIds.fleet.recipientGroupToggle}
                      onClick={() => toggleAllGroupFeeds(group.feeds.map((feed) => feed.id))}
                      sx={{ display: "flex", gap: 2 }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          gap: 1,
                          ml: 0.5,
                          mb: 1,
                        }}
                      >
                        {activeChannels.some((feedId) => group.feeds.map((feed) => feed.id).includes(feedId)) ? (
                          <>
                            <Box sx={{ display: "flex" }}>
                              <CheckBoxIcon sx={{ color: theme.palette.info.main }} />
                            </Box>
                            <Box>De-Select All</Box>
                          </>
                        ) : (
                          <>
                            <Box sx={{ display: "flex" }}>
                              <CheckBoxOutlineBlankIcon
                                sx={{
                                  color: theme.palette.brand.other.gray.main,
                                }}
                              />
                            </Box>
                            <Box>Select All</Box>
                          </>
                        )}
                      </Box>
                    </Box>
                  )}
                  <RecipientFeedList
                    id={`group-${group.id}`}
                    feeds={group.feeds}
                    activeChannels={activeChannels}
                    toggleSingleFeed={toggleSingleFeed}
                  />
                </Box>
              </Collapse>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
});
